const baseFitmentFields = ['Year', 'Make', 'Model'];
const extraFitmentFields = [];
const wheelsFields = ['wheel_diameter', 'wheel_width', 'wheel_bolt_pattern'];
const tiresFields = ['tire_system', 'tire_width', 'tire_aspect', 'tire_height', 'tire_rim'];
const ignoreFields = [...wheelsFields, ...tiresFields];

const categorySelectionPageUrl = '/categories/';
const brandSelectionPageUrl = '/brands/';

window.Convermax.handleProductCompareClick = () => {
  const productsIdsToCompare = [...window.document.querySelectorAll('input[name="products[]"]:checked')].map(
    (product) => product.dataset.compareId,
  );
  const compareBtn = window.document.body.querySelector('.compareTool');
  const compareCount = window.document.body.querySelector('.compareTool .countPill');
  if (!compareBtn) {
    return;
  }

  compareCount.textContent = productsIdsToCompare.length;
  compareBtn.classList.toggle('show', productsIdsToCompare.length > 1);
  compareBtn.href = `/compare/${productsIdsToCompare.join('/')}/`;
};

export default {
  platform: 'bigcommerce',
  sortFields: ['relevance', 'name', 'name:desc', 'price', 'price:desc'],
  SearchRequestDefaults: {
    pageSize: 36,
    extra: window.location.pathname === '/' ? { doNotHideWheelsTiresFacets: true } : {},
  },
  page: {
    getPageType: (defaults) =>
      window.location.pathname === categorySelectionPageUrl ||
      window.location.pathname === brandSelectionPageUrl
        ? 'parts'
        : defaults.getter(),
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'category' },
      { pathname: brandSelectionPageUrl, field: 'brand_name' },
    ],
    categorySelectionPageRedirect: true,
    onVehicleSelected: () => {
      const isMenuOpened = window.document
        .querySelector('.navPages-container')
        ?.classList.contains('is-open');
      const menuCloseElement = window.document.querySelector('#mobileCloseSarch');
      if (isMenuOpened && menuCloseElement) {
        menuCloseElement.click();
      }
    },
  },
  facets: {
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: '.page',
      template: 'SearchPage',
      visibleIf: () =>
        window.document.body.classList.contains('page-type-category') ||
        window.document.body.classList.contains('page-type-brand'),
    },
    {
      name: 'SearchHeader',
      sortSelectClass: 'form-select',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
    },
    { name: 'SearchResult' },
    {
      name: 'SearchBox',
      location: '.desktop-search.main-search',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxSmallerDesktop',
      type: 'SearchBox',
      location: '.desktop-search.small-desktop-flex--search',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: '#quick-search-expand',
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: '.convermax-section--home #tab-vehicle',
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 680,
    },
    {
      name: 'HomeWheelPanel_tab',
      type: 'RequestPanel',
      location: '.convermax-section--home #tab-wheels',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: wheelsFields,
    },
    {
      name: 'HomeTirePanel_tab',
      type: 'RequestPanel',
      location: '.convermax-section--home #tab-tires',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: tiresFields,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      isVehicleSelectionIsolated: true,
    },
    {
      name: 'SingleVehicleGarage',
      location: {
        selector: '.select-vehicle-wrap .select-vehicle',
        class: 'cm_single-vehicle-garage cm_single-vehicle-garage__desktop',
      },
      template: 'fitmentSearch/singleVehicleGarage',
    },
    {
      name: 'SingleVehicleGarageMobile',
      type: 'SingleVehicleGarage',
      location: {
        selector: '#menu .select-vehicle__mobile .navPages-action',
        class: 'cm_single-vehicle-garage cm_single-vehicle-garage__mobile',
      },
      template: 'fitmentSearch/singleVehicleGarage',
    },
    {
      name: 'VerifyFitment',
      location: { insertAfter: '.productView-price' },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FitmentTable',
      location: '#tab-fitment',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: '#fitmentTab',
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '.category-page-wrap',
      template: 'facetTiles/hierarchicalContainer',
      visibleIf: () => window.location.pathname === categorySelectionPageUrl,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: { replace: '.brandGrid', class: 'container' },
      template: 'facetTiles/alphabeticalContainer',
      view: 'columns',
      visibleIf: () => window.location.pathname === brandSelectionPageUrl,
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
  ],
};
